"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypingIndicatorVisible = useTypingIndicatorVisible;
exports.default = void 0;

var _useActiveTyping7 = _interopRequireDefault(require("./hooks/useActiveTyping"));

var _useRenderTypingIndicator = _interopRequireDefault(require("./hooks/useRenderTypingIndicator"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useTypingIndicatorVisible() {
  var _useActiveTyping = (0, _useActiveTyping7.default)(),
      _useActiveTyping2 = _slicedToArray(_useActiveTyping, 1),
      activeTyping = _useActiveTyping2[0];

  return [!!Object.values(activeTyping).filter(function (_ref) {
    var role = _ref.role;
    return role !== 'user';
  }).length];
}

var BasicTypingIndicator = function BasicTypingIndicator() {
  var _useActiveTyping3 = (0, _useActiveTyping7.default)(),
      _useActiveTyping4 = _slicedToArray(_useActiveTyping3, 1),
      activeTyping = _useActiveTyping4[0];

  var _useTypingIndicatorVi = useTypingIndicatorVisible(),
      _useTypingIndicatorVi2 = _slicedToArray(_useTypingIndicatorVi, 1),
      visible = _useTypingIndicatorVi2[0];

  var _useActiveTyping5 = (0, _useActiveTyping7.default)(Infinity),
      _useActiveTyping6 = _slicedToArray(_useActiveTyping5, 1),
      typing = _useActiveTyping6[0];

  var renderTypingIndicator = (0, _useRenderTypingIndicator.default)();
  return renderTypingIndicator({
    activeTyping: activeTyping,
    typing: typing,
    visible: visible
  });
};

var _default = BasicTypingIndicator;
exports.default = _default;